export const INSIGHT_TYPE = Object.freeze({
    DOB: "DOB",
    NAME: "NAME",
    DETAILS: "DETAILS",
    ID_NAME: "ID_NAME",
    ID_DOB: "ID_DOB",
    ID_NO_DATA: "ID_NO_DATA"
});
